(function (gdhelp2) {

  gdhelp2.utils = (function () {

    var inIframe = function () {
      return (window !== window.top);
    };

    var getSSOLink = function () {
      var nameparts = document.location.hostname.split('.');
      nameparts[0] = 'sso';
      var ssohost = 'https://' + nameparts.join('.');
      return ssohost + '/?realm=idp&app=help&path=' + encodeURIComponent(
        document.location.pathname + document.location.search + document.location.hash);
    };

    return {
      inIframe: inIframe,
      getSSOLink: getSSOLink
    };

  }());

}(window.gdhelp2 = window.gdhelp2 || {}, jQuery));
